<!--
 * @Author: your name
 * @Date: 2020-07-31 14:25:31
 * @LastEditTime: 2021-06-16 16:32:58
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\pages\form\select-people\select-people.vue
-->
<template>
  <div class="select-people">
    <div class="select-people-artical">
      <div class="search-bar">
        <x-input-search placeholder="搜索员工" @search="doSearch"></x-input-search>
      </div>
      <template v-if="keyWord">
        <div class="people-content">
          <cube-scroll
            v-if="!showEmpty"
            ref="scroll"
            :data="users"
            :options="cubeScrollOptions"
            @pulling-up="onPullingUp"
          >
            <template v-for="user in users">
              <div :key="user.id" class="item-wrapper" @click="handleCheckUser(user, $event)">
                <div class="item people">
                  <div class="check-block">
                    <template v-if="selectType === 'SINGLE'">
                      <x-svg-icon v-if="user.checked" name="x-lib-radio-active"></x-svg-icon>
                      <x-svg-icon v-else name="x-lib-radio"></x-svg-icon>
                    </template>
                    <template v-else>
                      <x-svg-icon v-if="user.checked" name="x-lib-checkbox-active"></x-svg-icon>
                      <x-svg-icon v-else name="x-lib-checkbox"></x-svg-icon>
                    </template>
                  </div>
                  <div class="content-block">
                    <x-person-avatar :avatarUrl="user.headPortrait" :personName="user.username"></x-person-avatar>
                    <span class="title">{{ user.username }}</span>
                    <span class="sub-title">{{ user.userNumber }}</span>
                  </div>
                </div>
              </div>
            </template>
          </cube-scroll>
          <x-empty v-if="showEmpty"></x-empty>
        </div>
      </template>
      <template v-else>
        <div ref="breadcrumbs" class="breadcrumbs">
          <template v-for="(item, index) in navMenu">
            <div ref="breadItem" :key="index" class="bread-item" @click="handleBack(item, index)">
              <span class="bread-title" :class="{ active: (index < navMenu.length - 1) }">{{ item.name }}</span>
              <x-svg-icon v-if="index < navMenu.length - 1" name="arrow-right-icon"></x-svg-icon>
            </div>
          </template>
        </div>
        <div class="people-content">
          <template v-for="dept in depts">
            <div :key="dept.id" class="item-wrapper" @click="handleClickDept(dept)">
              <div class="item dept">
                <div class="content-block">
                  <span class="title">{{ dept.name }}</span>
                  <span class="sub-title">({{ dept.userCount }}人)</span>
                </div>
                <div class="opt-block">
                  <x-svg-icon name="arrow-right-icon"></x-svg-icon>
                </div>
              </div>
              <!-- <div class="dept-line"></div> -->
            </div>
          </template>
          <template v-for="user in users">
            <div :key="user.id" class="item-wrapper" @click="handleCheckUser(user, $event)">
              <div class="item people">
                <div class="check-block">
                  <template v-if="selectType === 'SINGLE'">
                    <x-svg-icon v-if="user.checked" name="x-lib-radio-active"></x-svg-icon>
                    <x-svg-icon v-else name="x-lib-radio"></x-svg-icon>
                  </template>
                  <template v-else>
                    <x-svg-icon v-if="user.checked" name="x-lib-checkbox-active"></x-svg-icon>
                    <x-svg-icon v-else name="x-lib-checkbox"></x-svg-icon>
                  </template>
                </div>
                <div class="content-block">
                  <x-person-avatar
                    :avatarUrl="user.headPortrait"
                    :personName="user.username"
                  ></x-person-avatar>
                  <span class="title">{{ user.username }}</span>
                  <span class="sub-title">{{ user.userNumber }}</span>
                </div>
              </div>
            </div>
          </template>
          <x-empty v-if="(!depts || depts.length === 0) && (!users || users.length === 0)"></x-empty>
          <!-- <div class="item dept">
            <div class="check-block">
              <x-svg-icon v-if="true" name="x-lib-checkbox-active"></x-svg-icon>
              <x-svg-icon v-else name="x-lib-checkbox"></x-svg-icon>
            </div>
            <div class="content-block">
              <span class="title">营销部</span>
              <span class="sub-title">(41人)</span>
            </div>
            <div class="opt-block">
              <x-svg-icon name="arrow-right-icon"></x-svg-icon>
            </div>
          </div>
          <div class="dept-line"></div>
          <div class="item people">
            <div class="check-block">
              <x-svg-icon v-if="false" name="x-lib-checkbox-active"></x-svg-icon>
              <x-svg-icon v-else name="x-lib-checkbox"></x-svg-icon>
            </div>
            <div class="content-block">
              <x-person-avatar
                :avatarUrl="'http://portal.definesys.com:30502/xdap-admin/attachments/downloadFile?file=14f67d9a-b4ed-46c3-8fa1-250dc04f10f9&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJleHAiOjE1OTYxODM5MTIsImlhdCI6MTU5NjE3NjcxMiwieGRhcHVzZXJpZCI6IjU4NjQ0NzAwMjg1ODk0NjU2In0.UUWkiG5hX5s3-qb3qkIxmgyqoBBT9GwH3YU5uPz3V0ghKyXl78Uqm7NhUoT4wy62CsFGUtlCWK-X4MalyZSjCQ'"
                :personName="'张三'"
              ></x-person-avatar>
              <span class="title">吕顺</span>
              <span class="sub-title">006</span>
            </div>
          </div>-->
        </div>
      </template>
    </div>
    <div class="select-people-footer">
      <template v-if="selectType === 'SINGLE'">
        <div class="footer--info text-ellipsis">
          <span class="footer--help">
            单选，已选择「{{ (selectedArray && selectedArray.length > 0) ? selectedArray[0].username : '' }}」
          </span>
        </div>
        <cube-button class="confirm-btn" :primary="true" :inline="true" @click="handleConfirm">
          确定
        </cube-button>
      </template>
      <template v-else>
        <div class="check-block" @click="handleCheckAll">
          <x-svg-icon v-if="checkAll" name="x-lib-all-checkbox-active"></x-svg-icon>
          <x-svg-icon v-else name="x-lib-all-checkbox"></x-svg-icon>
        </div>
        <div class="selected-block">
          <x-tag-group :tags="selectedArray" calcKey="username" :tagMarginWidth="3" :countWidth="0" :tagPaddingWidth="0">
            <template v-slot:tag="{ tag }">
              <x-person-avatar
                :key="tag.id"
                :avatarUrl="tag.headPortrait"
                :personName="tag.username"
              ></x-person-avatar>
            </template>
          </x-tag-group>
        </div>
        <cube-button class="confirm-btn" :primary="true" :inline="true" @click="handleConfirm">
          确定
        </cube-button>
      </template>
    </div>
  </div>
</template>

<script>
import apis from '@/api'
import { mapState, mapMutations } from 'vuex'
import { SET_COMP_VALUE } from '@/store/comp-router.store.js'
import {
  SET_SELECTED_ARRAY,
  PUSH_SELECTED_ITEM,
  POP_SELECTED_ITEM,
  REMOVE_SELECTED_ITEM,
  PUSH_NAV_ITEM,
  POP_NAV_ITEM,
  RESET_PEOPLE_STORE
} from '@/store/select-people.store.js'

export default {
  data() {
    return {
      compPayloadKey: this.$route.query.key,
      keyWord: null,
      depts: [],
      users: [],
      checkAll: false,
      cubeScrollOptions: {
        // preventDefault: false,
        pullDownRefresh: false,
        pullUpLoad: {
          txt: {
            more: '上滑加载更多',
            noMore: '没有更多数据了'
          }
        },
        scrollbar: false
      },
      tableConfig: {
        loading: false,
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        }
      },
      isTile: false
    }
  },
  computed: {
    ...mapState({
      compPayload: (state) => state.compRouterModule.compPayload,
      navMenu: (state) => state.selectPeopleModule.navMenu,
      selectedArray: (state) => state.selectPeopleModule.selectedArray
    }),
    selectType() {
      return this.compPayload[this.compPayloadKey].widgetConfig.chooseType
    },
    showEmpty: function () {
      return (!this.users || this.users.length === 0) && !this.tableConfig.loading
    }
  },
  watch: {
    '$route.params.id': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.checkAll = false
          // 判断是否需要走数据过滤接口
          let widget = this.$lodash.cloneDeep(this.compPayload[this.compPayloadKey].widgetConfig)
          this.isTile = (function () {
            if (
              widget.selectedDataSourceList === undefined ||
              widget.selectedDataSourceList.length === 0
            ) {
              // 如果没有数据来源或数据来源为空则使用老接口
              return false
            } else {
              if (widget.selectedDataSourceList[0].type === 'personSelectAll') {
                // 如果来源为全部 且 不存在过滤条件则走老接口
                if (
                  widget.filterConditionGroupList &&
                  widget.filterConditionGroupList.length > 0
                ) {
                  for (const item of widget.filterConditionGroupList) {
                    if (item.selectorFilterConditionList && item.selectorFilterConditionList.length > 0) {
                      return true
                    }
                  }
                }
                return false
              }
            }
            return true
          })()
          this.$nextTick(() => {
            this.$refs.breadItem[this.$refs.breadItem.length - 1].scrollIntoView()
          })
          const deptId = newVal === 'all' ? null : newVal
          // this.queryDeptByDeptId(deptId)
          if (this.isTile) {
            this.queryAllUsersFilter('', this.tableConfig.pagination.currentPage,
              this.tableConfig.pagination.pageSize)
          } else {
            this.queryChildDeptAndUser(deptId)
          }
        }
      },
      immediate: true
    }
  },
  created() {
    if (this.compPayload[this.compPayloadKey].value instanceof Array) {
      this.setSelectedArray(this.$lodash.cloneDeep(this.compPayload[this.compPayloadKey].value))
    }
  },
  mounted() {
    window.addEventListener('popstate', this.goBack, false)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack, false)
    this.resetPeopleStore()
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompValue: SET_COMP_VALUE
    }),
    ...mapMutations('selectPeopleModule', {
      setSelectedArray: SET_SELECTED_ARRAY,
      pushSelectedItem: PUSH_SELECTED_ITEM,
      popSelectedItem: POP_SELECTED_ITEM,
      removeSelectedItem: REMOVE_SELECTED_ITEM,
      pushNavItem: PUSH_NAV_ITEM,
      popNavItem: POP_NAV_ITEM,
      resetPeopleStore: RESET_PEOPLE_STORE
    }),
    goBack() {
      this.popNavItem()
    },
    queryDeptByDeptId(deptId) {
      const request = { ...apis.APP_PAGE.QUERY_DEPARTMENT_INFO }
      request.params = {
        deptId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.depts = resp.table
          },
          (err) => {
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          console.error(err)
        })
    },
    queryChildDeptAndUser(deptId) {
      const request = { ...apis.APP_PAGE.QUERY_CHILD_DEPT_AND_USER }
      request.params = {
        deptId
      }
      this.tableConfig.loading = true
      this.$loading.show()
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            this.depts = resp.data.deptList
            if (resp.data.userList) {
              resp.data.userList.forEach((user) => {
                const temp = this.selectedArray.find((item) => item.id === user.id)
                if (temp) {
                  user.checked = true
                } else {
                  user.checked = false
                }
              })
              this.users = resp.data.userList
            } else {
              this.users = []
            }
          },
          (err) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.tableConfig.loading = false
          this.$loading.hide()
          console.error(err)
        })
    },
    queryAllUsers(keyWord, page, pageSize) {
      const request = { ...apis.APP_PAGE.QUERY_ALL_USERS }
      request.params = {
        keyWord: keyWord,
        page: page,
        pageSize: pageSize
      }
      this.tableConfig.loading = true
      this.$loading.show()
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            if (request.params.page === 1) {
              this.users = []
            }
            if (!resp.table || resp.table.length === 0) {
              this.$refs.scroll.forceUpdate()
            } else {
              resp.table.forEach((user) => {
                const temp = this.selectedArray.find((item) => item.id === user.id)
                if (temp) {
                  user.checked = true
                } else {
                  user.checked = false
                }
              })
              this.users = this.users.concat(resp.table || [])
              this.tableConfig.pagination.currentPage = page
              this.tableConfig.pagination.pageSize = pageSize
              this.tableConfig.pagination.total = resp.total
              if (this.users.length === resp.total) {
                this.$refs.scroll.forceUpdate()
              }
            }
          },
          (err) => {
            this.$refs.scroll.forceUpdate()
            this.tableConfig.loading = false
            this.$loading.hide()
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.$refs.scroll.forceUpdate()
          this.tableConfig.loading = false
          this.$loading.hide()
          console.error(err)
        })
    },
    queryAllUsersFilter(keyWord, page, pageSize) {
      const request = { ...apis.APP_PAGE.QUERY_ALL_USERS_FILTER }
      request.params = {
        param: {
          keyWord: keyWord,
          page: page,
          pageSize: pageSize
        },
        formId: this.$route.query.formId,
        formData: this.compPayload[this.$route.query.key].formData,
        componentId: this.$route.query.key
      }
      this.tableConfig.loading = true
      this.$loading.show()
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            if (request.params.page === 1) {
              this.users = []
            }
            if (!resp.table || resp.table.length === 0) {
              this.$refs.scroll.forceUpdate()
            } else {
              resp.table.forEach((user) => {
                const temp = this.selectedArray.find((item) => item.id === user.id)
                if (temp) {
                  user.checked = true
                } else {
                  user.checked = false
                }
              })
              this.users = this.users.concat(resp.table || [])
              this.tableConfig.pagination.currentPage = page
              this.tableConfig.pagination.pageSize = pageSize
              this.tableConfig.pagination.total = resp.total
              if (this.users.length === resp.total) {
                this.$refs.scroll.forceUpdate()
              }
            }
          },
          (err) => {
            this.$refs.scroll.forceUpdate()
            this.tableConfig.loading = false
            this.$loading.hide()
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.$refs.scroll.forceUpdate()
          this.tableConfig.loading = false
          this.$loading.hide()
          console.error(err)
        })
    },
    handleCheckUser(user, e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.selectType === 'SINGLE') {
        const flag = user.checked
        this.users.forEach((item) => {
          this.$set(item, 'checked', false)
        })
        this.$set(user, 'checked', !flag)
        if (user.checked) {
          this.setSelectedArray([ user ])
        } else {
          this.setSelectedArray([])
        }
      } else {
        if (this.selectedArray && this.selectedArray.length >= 30) {
          this.$message({
            message: '最多只能添加30个人',
            type: 'error'
          })
          return
        }
        this.$set(user, 'checked', !user.checked)
        if (user.checked) {
          this.pushSelectedItem(user)
        } else {
          this.removeSelectedItem(user)
        }
      }
    },
    handleClickDept(dept) {
      this.pushNavItem(dept)
      this.$router.push({ name: 'FormPeopleSelect', params: { id: dept.id }, query: this.$route.query })
    },
    doSearch(e) {
      this.keyWord = e
      this.tableConfig.pagination.currentPage = 1
      if (this.keyWord) {
        if (this.isTile) {
          this.queryAllUsersFilter(this.keyWord,
            this.tableConfig.pagination.currentPage,
            this.tableConfig.pagination.pageSize)
        } else {
          this.queryAllUsers(
            this.keyWord,
            this.tableConfig.pagination.currentPage,
            this.tableConfig.pagination.pageSize
          )
        }
      } else {
        if (this.isTile) {
          this.queryAllUsersFilter(this.keyWord,
            this.tableConfig.pagination.currentPage,
            this.tableConfig.pagination.pageSize)
        } else {
          const deptId = this.$route.params.id === 'all' ? null : this.$route.params.id
          this.queryChildDeptAndUser(deptId)
        }
      }
    },
    onPullingUp(e) {
      this.queryAllUsers(
        this.keyWord,
        this.tableConfig.pagination.currentPage + 1,
        this.tableConfig.pagination.pageSize
      )
    },
    handleBack(department, index) {
      if (index !== this.navMenu.length - 1) {
        const step = this.navMenu.length - index - 1
        for (let i = 0; i < step - 1; i++) { // 此处少减的一个会在popstate中减掉
          this.popNavItem()
        }
        this.$router.go(-step)
      }
    },
    handleConfirm() {
      this.setCompValue({
        key: this.$route.query.key,
        value: this.$lodash.cloneDeep(this.selectedArray)
      })
      this.$router.go(-this.navMenu.length)
    },
    handleCheckAll() {
      this.checkAll = !this.checkAll
      for (const user of this.users) {
        if (this.selectedArray.length >= 30) {
          this.$message({
            message: '最多只能添加30个人',
            type: 'error'
          })
          break
        }
        this.$set(user, 'checked', this.checkAll)
        if (user.checked) {
          if (this.selectedArray.filter((item) => item.id === user.id).length === 0) {
            this.pushSelectedItem(user)
          }
        } else {
          this.removeSelectedItem(user)
        }
      }
      this.setSelectedArray([...this.selectedArray])
    }
  }
}
</script>

<style lang="scss">
.select-people {
  height: 100%;
  background-color: #f7f7f7;
  .select-people-artical {
    height: calc(100% - 3.714rem);
    display: flex;
    flex-flow: column;
    .search-bar {
      background-color: #fff;
    }
    .breadcrumbs {
      height: 2.857rem;
      line-height: 2.857rem;
      box-sizing: border-box;
      padding: 0.71rem 0.857rem;
      overflow-y: hidden;
      overflow-x: auto;
      display: flex;
      align-items: center;
      background-color: #fff;
      color: #b2b2b2;
      border-bottom: 1px solid $--app-hover-color;
      white-space: nowrap;
      .bread-item {
        display: flex;
        align-items: center;
        .x-svg-icon {
          display: flex;
        }
      }
      .bread-title {
        font-size: 1rem;
        &.active {
          color: $--app-primary-color;
        }
      }
    }
    .people-content {
      flex: 1;
      overflow-y: auto;
      .x-empty {
        margin: 40% auto;
      }
      .item {
        height: 3.642rem;
        padding: 1rem 0.857rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        background-color: #fff;
        &.dept {
          border-bottom: 1PX solid #F5F7FA;
        }
        .check-block {
          width: 1.714rem;
          height: 1.714rem;
          margin-right: 0.857rem;
          color: #B2B2B2;
          .svg-x-lib-radio-active, .svg-x-lib-checkbox-active, .svg-x-lib-all-checkbox-active {
            color: $--app-primary-color;
          }
        }
        .content-block {
          flex: 1;
          display: flex;
          align-items: center;
          .x-person-avatar {
            margin-right: 0.571rem;
            width: 2.571rem;
            min-width: 2.571rem;
            height: 2.571rem;
            min-height: 2.571rem;
            line-height: 2.571rem;
          }
          .title {
            color: #101010;
          }
          .sub-title {
            margin-left: 0.571rem;
            color: #b2b2b2;
          }
        }
        .opt-block {
          color: #b2b2b2;
        }
      }
      .dept-line {
        width: calc(100% - 3.423rem);
        height: 1px;
        margin-top: -1px;
        background-color: #fff;
        border-bottom: 1px solid $--app-hover-color;
        position: absolute;
        right: 0;
      }
    }
  }
  .select-people-footer {
    padding: 0.857rem;
    box-sizing: border-box;
    width: 100%;
    height: 3.714rem;
    position: absolute;
    bottom: 0;
    background-color: #fff;
    display: flex;
    .footer--info {
      display: flex;
      align-items: center;
      flex: 1;
      .footer--help {
        color: #B2B2B2;
      }
    }
    .check-block {
      width: 1.714rem;
      min-width: 1.714rem;
      height: 1.714rem;
      margin-right: .571rem;
      color: #B2B2B2;
      .svg-x-lib-radio-active, .svg-x-lib-checkbox-active, .svg-x-lib-all-checkbox-active {
        color: $--app-primary-color;
      }
    }
    .selected-block {
      flex: 1;
      display: flex;
      align-items: center;
      .x-person-avatar {
        margin-right: 0.285rem;
      }
    }
    .confirm-btn {
      width: 4.642rem;
      min-width: 4.642rem;
      height: 2.285rem;
      font-size: 1rem;
    }
  }
}
</style>
